module.exports = __webpack_public_path__ + "static/media/happyFace.4cdecab8.svg";